// extracted by mini-css-extract-plugin
module.exports = {"LinkWrapper":"GridItem_LinkWrapper__LNpe9","Dash":"GridItem_Dash__e_PGi","quote":"GridItem_quote__21C_C","lineClamp":"GridItem_lineClamp__njiCp","name":"GridItem_name__eqjVK"};